import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Calendar, FileText, DollarSign, BarChart3, Settings, CheckSquare } from 'lucide-react';

const MobileNav = ({ user }) => {
  const location = useLocation();
  const isAdmin = user?.role === 'admin';

  const navItems = [
    { path: '/dashboard', icon: Home, label: 'Home' },
    { path: '/events', icon: Calendar, label: 'Events' },
    { path: '/budgets', icon: DollarSign, label: 'Budget' },
    ...(isAdmin ? [{ path: '/approvals', icon: CheckSquare, label: 'Approvals' }] : []),
    { path: '/expenses/new', icon: FileText, label: 'Expense' },
    { path: '/reports', icon: BarChart3, label: 'Reports' },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 h-16 bg-white/90 backdrop-blur-lg border-t border-border flex items-center justify-around z-50 pb-safe">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return (
          <Link
            key={item.path}
            to={item.path}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            className={`flex flex-col items-center justify-center px-3 py-2 transition-all ${
              isActive ? 'text-primary' : 'text-muted-foreground'
            }`}
          >
            <Icon className={`h-5 w-5 ${ isActive ? 'scale-110' : '' }`} />
            <span className="text-xs mt-1 font-medium">{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default MobileNav;
